




































































import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    isLoggedIn: function(): boolean {
      return this.$store.getters.isLoggedIn;
    },
    isAdmin: function(): boolean {
      return this.$store.getters.isAdmin;
    },
    user: function(): string {
      return this.$store.getters.user;
    },
    navClass: function(): any {
      return {
        open: this.isOpen
      };
    },
    visibleStyle: function(): any {
      const visibility = this.isOpen ? "visible" : "hidden";
      const opacity = this.isOpen ? 0.2 : 0;
      return {
        visibility: visibility,
        opacity: opacity
      };
    }
  },
  methods: {
    openNav: function(): void {
      this.isOpen = !this.isOpen;
    },
    closeNav: function(): void {
      this.isOpen = false;
    },
    loginout: function(): void {
      if (this.$store.getters.isLoggedIn) {
        this.$router.push({ name: "logout" }).catch(() => {});
      } else {
        this.$router.push({ name: "login" }).catch(() => {});
      }
      this.closeNav();
    },
    gotoSignup: function(): void {
      this.$router.push({ name: "signup" }).catch(() => {});
    }
  },
  watch: {
    "$route.fullPath": function() {
      this.closeNav();
    }
  }
});
